// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Intakes.css */

/* Basic styling for the intake list */
.intake-list {
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
  }
  
  /* Styling for filters */
  .filters {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  
  .filters select,
  .filters input {
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-right: 10px;
    width: 150px;
  }
  
  .filters input[type="date"] {
    width: 200px;
  }
  
  /* Styling for intake cards */
  .intake-card {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    background-color: #f9f9f9;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;
  }
  
  .intake-card:hover {
    transform: translateY(-5px);
  }
  
  /* Title styling */
  .intake-title {
    font-size: 22px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
  }
  
  /* Current intake styling */
  .current-intake {
    font-weight: bold;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block;
  }
  
  .current-intake.active {
    color: white;
    background-color: #28a745;
  }
  
  .current-intake.inactive {
    color: white;
    background-color: #dc3545;
  }
  
  /* Button styling */
  .btn-primary {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 8px 16px;
    margin: 8px 0;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .btn-success {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 8px 16px;
    margin: 8px 0;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .btn-primary:hover,
  .btn-success:hover {
    opacity: 0.9;
  }
  
  /* Modal overlay */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  /* Modal content */
  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    width: 90%;
    max-width: 500px;
    position: relative;
  }
  
  /* Close button for modals */
  .modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    cursor: pointer;
  }
  
  /* Form styling */
  .add-intake-form div {
    margin-bottom: 10px;
  }
  
  .add-intake-form label {
    display: block;
    margin-bottom: 5px;
  }
  
  .add-intake-form input,
  .add-intake-form textarea {
    width: calc(100% - 20px);
    padding: 8px;
    margin: 0;
    box-sizing: border-box;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Intakes/Intakes.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B,sCAAsC;AACtC;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;EAChB;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA,6BAA6B;EAC7B;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;IACxC,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,kBAAkB;EAClB;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;EACrB;;EAEA,2BAA2B;EAC3B;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA,mBAAmB;EACnB;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA,kBAAkB;EAClB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA,kBAAkB;EAClB;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,4BAA4B;EAC5B;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;;IAEE,wBAAwB;IACxB,YAAY;IACZ,SAAS;IACT,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;EACpB","sourcesContent":["/* src/components/Intakes.css */\n\n/* Basic styling for the intake list */\n.intake-list {\n    padding: 20px;\n    max-width: 800px;\n    margin: 0 auto;\n  }\n  \n  /* Styling for filters */\n  .filters {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n  }\n  \n  .filters select,\n  .filters input {\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    margin-right: 10px;\n    width: 150px;\n  }\n  \n  .filters input[type=\"date\"] {\n    width: 200px;\n  }\n  \n  /* Styling for intake cards */\n  .intake-card {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 16px;\n    margin-bottom: 16px;\n    background-color: #f9f9f9;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: transform 0.2s;\n  }\n  \n  .intake-card:hover {\n    transform: translateY(-5px);\n  }\n  \n  /* Title styling */\n  .intake-title {\n    font-size: 22px;\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 10px;\n  }\n  \n  /* Current intake styling */\n  .current-intake {\n    font-weight: bold;\n    padding: 4px 8px;\n    border-radius: 4px;\n    display: inline-block;\n  }\n  \n  .current-intake.active {\n    color: white;\n    background-color: #28a745;\n  }\n  \n  .current-intake.inactive {\n    color: white;\n    background-color: #dc3545;\n  }\n  \n  /* Button styling */\n  .btn-primary {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    margin: 8px 0;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .btn-success {\n    background-color: #28a745;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    margin: 8px 0;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .btn-primary:hover,\n  .btn-success:hover {\n    opacity: 0.9;\n  }\n  \n  /* Modal overlay */\n  .modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  /* Modal content */\n  .modal-content {\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 500px;\n    position: relative;\n  }\n  \n  /* Close button for modals */\n  .modal-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 24px;\n    cursor: pointer;\n  }\n  \n  /* Form styling */\n  .add-intake-form div {\n    margin-bottom: 10px;\n  }\n  \n  .add-intake-form label {\n    display: block;\n    margin-bottom: 5px;\n  }\n  \n  .add-intake-form input,\n  .add-intake-form textarea {\n    width: calc(100% - 20px);\n    padding: 8px;\n    margin: 0;\n    box-sizing: border-box;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
